import { render, staticRenderFns } from "./ServiceLabItemDes.vue?vue&type=template&id=77d11b7d"
import script from "./ServiceLabItemDes.vue?vue&type=script&lang=js"
export * from "./ServiceLabItemDes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports